import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { func } from "prop-types";
import qrcode from "qrcode-js";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { puede } from "../../../../permisos/permisos";

function ListadoInventariosTelas() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS_TELAS = `${process.env.REACT_APP_URL_INVENTARIOS_TELAS}`;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_APARTADO_TELAS = process.env.REACT_APP_URL_APARTADO_TELAS;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;

  const [inventariosTelas, setInventariosTelas] = useState([]);
  const [inventariosTelasRollos, setInventariosTelasRollos] = useState([]);
  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccionesFiltro, setSelectedColeccionesFiltro] = useState("");
  const [colores, setColores] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");
  const [selectedComposicion, setSelectedComposicion] = useState("");
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [articulosComposicion, setArticulosComposicion] = useState([]);
  const [articuloDesgloce, setArticuloDesgloce] = useState("");
  const [nombreDesgloce, setNombreDesgloce] = useState("");
  const [codigoDesgloce, setCodigoDesgloce] = useState("");
  const [colorDesgloce, setColorDesgloce] = useState("");
  const [pesoDesgloce, setPesoDesgloce] = useState("");
  const [composicionDesgloce, setComposicionDesgloce] = useState("");
  const [unidadDesgloce, setUnidadDesgloce] = useState("");
  const [anchoDesgloce, setAnchoDesgloce] = useState("");
  const [idProveedorDesgloce, setIdProveedorDesgloce] = useState("");
  const [idComprasDesgloce, setIdComprasDesgloce] = useState("");

  const [idTelaApartado, setIdTelaApartado] = useState("");
  const [nombreApartado, setNombreApartado] = useState("");
  const [codigoApartado, setCodigoApartado] = useState("");
  const [idColorApartado, setIdColorApartado] = useState("");
  const [colorApartado, setColorApartado] = useState("");
  const [idComprasApartado, setIdComprasApartado] = useState("");
  const [apartadoTelas, setApartadoTelas] = useState([]);
  const [modalApartado, setModalApartado] = useState(false);
  const toggleApartado = () => setModalApartado(!modalApartado);
  const [cantidadApartado, setCantidadApartado] = useState("");
  const [observacionesApartado, setObservacionesApartado] = useState("");
  const [pedidos, setPedidos] = useState([]);
  const [selectedPedido, setSelectedPedido] = useState("");
  const [value, setValue] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [articulosCodigos, setArticulosCodigos] = useState([]);
  const [articulosNombre, setArticulosNombre] = useState([]);
  const [selectedCodigo, setSelectedCodigo] = useState("");
  const [selectedNombre, setSelectedNombre] = useState("");

  const [idRolloEdit, setIdRolloEdit] = useState("");
  const [articuloEdit, setArticuloEdit] = useState("");
  const [unidadEdit, setUnidadEdit] = useState("");
  const [cantidadEdit, setCantidadEdit] = useState("");
  const [picos, setPicos] = useState("");
  const [stock, setStock] = useState("");
  const [cantidadAnteriorEdit, setCantidadAnteriorEdit] = useState("");
  const [produccionEdit, setProduccionEdit] = useState("No");
  const [apartadoEdit, setApartadoEdit] = useState("No");
  const [idCompraEdit, setIdCompraEdit] = useState("");
  const [numeroCompraEdit, setNumeroCompraEdit] = useState("");

  const [idRolloHistorial, setIdRolloHistorial] = useState("");
  const [articuloHistorial, setArticuloHistorial] = useState("");
  const [unidadHistorial, setUnidadHistorial] = useState("");
  const [cantidadHistorial, setCantidadHistorial] = useState("");
  const [cantidadAnteriorHistorial, setCantidadAnteriorHistorial] = useState("");
  const [produccionHistorial, setProduccionHistorial] = useState("No");
  const [idCompraHistorial, setIdCompraHistorial] = useState("");
  const [numeroCompraHistorial, setNumeroCompraHistorial] = useState("");
  const [surtidoHistorial, setSurtidoHistorial] = useState("");

  const [mayorQue, setMayorQue] = useState(0);
  const [menorQue, setMenorQue] = useState(10000000);

  const [unidad, setUnidad] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [modalMailRollo, setModalMailRollo] = useState(false);
  const toggleMailRollo = () => setModalMailRollo(!modalMailRollo);

  const [modalDesgloce, setModalDesgloce] = useState(false);
  const toggleDesgloce = () => setModalDesgloce(!modalDesgloce);

  const [modalEditRollo, setModalEditRollo] = useState(false);
  const toggleEditRollo = () => setModalEditRollo(!modalEditRollo);

  const [modalCortarRollo, setModalCortarRollo] = useState(false);
  const toggleCortarRollo = () => setModalCortarRollo(!modalCortarRollo);
  const [cantidadCortar, setCantidadCortar] = useState("");
  const [rolloCortar, setRolloCortar] = useState("");


  const [totalRol, setTotalRol] = useState(0);
  const [totalCantidadMetros2, setTotalCantidadMetros2] = useState(0);
  const [totalCantidadMetros, setTotalCantidadMetros] = useState(0);
  const [totalCantidadKilos, setTotalCantidadKilos] = useState(0);
  const [totalCosto, setTotalCosto] = useState(0);

  const [modalHistorialRollo, setModalHistorialRollo] = useState(false);
  const toggleHistorialRollo = () =>
    setModalHistorialRollo(!modalHistorialRollo);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS_TELAS}Acumulado`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventariosTelas = response.data;
        // Array para pagination
        let arrayTabla = allInventariosTelas
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            let metros2;
            if (a.unidad === "Metros") {
              metros2 = a.cantidad;
            } else if (a.unidad === "Kilos") {
              metros2 = a.cantidad * a.rendimiento;
            } else {
              metros2 = 0; // Default value or handle other cases
            }
            return {
              _id: a._id,
              cantidad: a.cantidad,
              codigo: a.codigo,
              nombre: a.nombre,
              idTela: a.idTela,
              composicion: a.composicion,
              descripcion: a.descripcion,
              unidad: a.unidad,
              ancho: a.ancho,
              peso: a.peso,
              rendimiento: a.rendimiento,
              idColecciones: a.idColecciones,
              colecciones: a.colecciones,
              costo: a.costo,
              costoTotal: a.costoTotal,
              observaciones: a.observaciones,
              colores: a.colores,
              idColores: a.idColores,
              idCompras: a.idCompras,
              rollos: parseFloat(a.rollos),
              idProveedor: a.idProveedor,
              proveedor: a.proveedor,
              compras: a.compras,
              metros2: metros2,
              factura: a.factura,
              fechaCompra: a.fechaCompra,
              observacionesCompra: a.observacionesCompra,
              apartado: a.apartado,
              disponible: metros2 - a.apartado,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setInventariosTelas(dataFinal);
        setComments(dataFinal);

        var items = dataFinal.map((a) => {
          return a.composicion;
        });

        const unicos = [];
        for (var i = 0; i < items.length; i++) {
          const elemento = items[i];

          if (!unicos.includes(items[i])) {
            unicos.push(elemento);
          }
        }
        setArticulosComposicion(unicos);

        var itemsCodigos = dataFinal.map((a) => {
          return a.codigo;
        });

        let agrupadoCodigos = dataFinal.reduce(function (groups, item) {
          const val = item["codigo"];
          groups[val] = groups[val] || {
            codigo: item.codigo,
            cantidad: 0,
          };
          groups[val].codigo = item.codigo;
          groups[val].idTela = item.idTela;
          groups[val].cantidad += item.cantidad;
          return groups;
        }, []);
        let dataFinalCodigos = Object.values(agrupadoCodigos);
        setArticulosCodigos(dataFinalCodigos);

        let agrupadoNombres = dataFinal.reduce(function (groups, item) {
          const val = item["nombre"];
          groups[val] = groups[val] || {
            nombre: item.nombre,
            idTela: "",
          };
          groups[val].nombre = item.nombre;
          groups[val].idTela = item.idTela;
          return groups;
        }, []);
        let dataFinalNombres = Object.values(agrupadoNombres);
        setArticulosNombre(dataFinalNombres);
      })

      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColecciones = response.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColores = response.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_PEDIDOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allPedidos = res.data;
        setPedidos(allPedidos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function PDFTabla() {
    let total_general = 0;
    let total_generalCosto = 0;

    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idTela"] + item["idColores"];
      groups[val] = groups[val] || {
        idTela: item.idTela,
        idColores: item.idColores,
        cantidad: 0,
        rollos: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].nombre = item.nombre;
      groups[val].idTela = item.idTela;
      groups[val].composicion = item.composicion;
      groups[val].descripcion = item.descripcion;
      groups[val].unidad = item.unidad;
      groups[val].ancho = item.ancho;
      groups[val].peso = item.peso;
      groups[val].rendimiento = item.rendimiento;
      groups[val].idColecciones = item.idColecciones;
      groups[val].colecciones = item.colecciones;
      groups[val].costo = item.costo;
      groups[val].costoTotal = item.costoTotal;
      groups[val].observaciones = item.observaciones;
      groups[val].colores = item.colores;
      groups[val].idColores = item.idColores;
      groups[val].rollos += item.rollos;
      groups[val].idProveedor = item.idProveedor;
      groups[val].proveedor = item.proveedor;
      groups[val].factura = item.factura;
      groups[val].fechaCompra = item.fechaCompra;
      groups[val].observacionesCompra = item.observacionesCompra;
      return groups;
    }, []);

    let computedComments = Object.values(agrupado);

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
          comment.unidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.colecciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.colores.toLowerCase().includes(search.toLowerCase()) ||
          comment.factura.toLowerCase().includes(search.toLowerCase()) ||
          comment.observacionesCompra.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.ancho.toString().includes(search) ||
          comment.peso.toString().includes(search) ||
          comment.costo.toString().includes(search) ||
          comment.costoTotal.toString().includes(search) ||
          comment.rollos.toString().includes(search) ||
          comment.codigo.toString().includes(search)
      );
    }


    if (selectedColeccionesFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idColecciones.includes(selectedColeccionesFiltro)
      );
    }
    if (selectedColor) {
      computedComments = computedComments.filter((e) =>
        e.idColores.includes(selectedColor)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e.idTela.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e.idTela.includes(selectedNombre)
      );
    }
    if (unidad) {
      computedComments = computedComments.filter((e) =>
        e.unidad.includes(unidad)
      );
    }
    if (selectedComposicion) {
      computedComments = computedComments.filter((e) =>
        e.composicion.includes(selectedComposicion)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }

    if (mayorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad >= mayorQue
      );
    }

    if (menorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad <= menorQue
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "ancho" &&
      sorting.field != "peso" &&
      sorting.field != "costo" &&
      sorting.field != "costoTotal" &&
      sorting.field != "rollos" &&
      sorting.field != "codigo" &&
      sorting.field != "costoMt"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "ancho" ||
        sorting.field == "peso" ||
        sorting.field != "costo" ||
        sorting.field != "costoTotal" ||
        sorting.field != "rollos" ||
        sorting.field != "codigo" ||
        sorting.field != "costoMt")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "ancho" ||
        sorting.field == "peso" ||
        sorting.field != "costo" ||
        sorting.field != "costoTotal" ||
        sorting.field != "rollos" ||
        sorting.field != "codigo" ||
        sorting.field != "costoMt")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    const data = computedComments
      .map((a) => {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad);
          total_generalCosto =
            parseFloat(total_generalCosto) + parseFloat(a.costoTotal);
          return [
            a.codigo,
            a.nombre,
            a.colores,
            a.unidad,
            new Intl.NumberFormat("en-US").format(a.cantidad),
          ];
        }
      );
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado InventariosTelas 333`, 20, 40);
    doc.autoTable({
      // styles: {
      //     valign: 'center'
      // },
      headStyles: {
        valign: "middle",
        halign: "center",
      },
      footStyles: {
        valign: "middle",
        halign: "right",
      },
      columnStyles: {
        0: { minCellWidth: 20 },
        1: { minCellWidth: 20 },
        2: { minCellWidth: 18 },
        3: { minCellWidth: 10, fontSize: 8 },
        4: {
          minCellWidth: 20,
          // valign: 'center'
        },
        5: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        6: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        // 7:{ minCellWidth: 20,
        //   // valign: 'center'
        //  },
        8: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        9: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        10: {
          minCellWidth: 22,
          halign: "right",
          // valign: 'center'
        },
        11: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        12: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
      },
      head: [
        [
          "Codigo",
          "Nombre",
          "Color",
          "Unidad",
          "Cantidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`InventariosTelas.pdf`);
  }

  function excel() {
    
    const dataExcel = comments
      .map((a) => { 
        if (
          (selectedCodigo == 0 || selectedCodigo == a.idTela) &&
          (selectedNombre == 0 || selectedNombre == a.idTela) &&
          (selectedColor == 0 || selectedColor == a.idColores) &&
          (selectedComposicion == 0 || selectedComposicion == a.composicion) &&
          (unidad == 0 || unidad == a.unidad) &&
          (selectedColeccionesFiltro == 0 || selectedColeccionesFiltro == a.idColecciones) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor) &&
          (mayorQue == 0 || mayorQue <= a.cantidad) &&
          (menorQue == 0 || menorQue >= a.cantidad) 
        ) {
          return {
            Codigo: a.codigo,
            Nombre: a.nombre,
            Color: a.colores,
            Unidad: a.unidad,
            Cantidad: a.cantidad,
          }
        }
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoInventariosTelas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoInventariosTelas",
        sheetFilter: [
          "Codigo",
          "Nombre",
          "Color",
          "Unidad",
          "Cantidad",
        ],
        sheetHeader: [
          "Codigo",
          "Nombre",
          "Color",
          "Unidad",
          "Cantidad",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let total_general = 0;
    let total_generalCosto = 0;
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idTela"] + item["idColores"];
      groups[val] = groups[val] || {
        idTela: item.idTela,
        idColores: item.idColores,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].nombre = item.nombre;
      groups[val].idTela = item.idTela;
      groups[val].composicion = item.composicion;
      groups[val].descripcion = item.descripcion;
      groups[val].unidad = item.unidad;
      groups[val].ancho = item.ancho;
      groups[val].peso = item.peso;
      groups[val].rendimiento = item.rendimiento;
      groups[val].costo = item.costo;
      groups[val].costoTotal = item.costoTotal;
      groups[val].observaciones = item.observaciones;
      groups[val].colores = item.colores;
      groups[val].idColores = item.idColores;
      groups[val].idProveedor = item.idProveedor;
      groups[val].proveedor = item.proveedor;
      return groups;
    }, []);

    let computedComments = Object.values(agrupado);

    const data = computedComments
      .filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
          comment.unidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.colores.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.ancho.toString().includes(search) ||
          comment.peso.toString().includes(search) ||
          comment.costo.toString().includes(search) ||
          comment.costoTotal.toString().includes(search) ||
          comment.rollos.toString().includes(search) ||
          comment.codigo.toString().includes(search)
      )
      .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
      .map((a) => {
        if (
          (selectedColor == 0 || selectedColor == a.idColores) &&
          (selectedCodigo == 0 || selectedCodigo == a.idTela) &&
          (selectedNombre == 0 || selectedNombre == a.idTela) &&
          (unidad == 0 || unidad == a.unidad) &&
          (selectedComposicion == 0 || selectedComposicion == a.composicion) &&
          (selectedProveedor == 0 || selectedProveedor == a.idProveedor)
        ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad);
          total_generalCosto =
            parseFloat(total_generalCosto) + parseFloat(a.costoTotal);
          return [
            a.codigo,
            a.nombre,
            a.colores,
            a.composicion,
            a.unidad,
            a.ancho,
            a.peso,
            // "$" + new Intl.NumberFormat("en-US").format(a.costo),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "$" + new Intl.NumberFormat("en-US").format(a.costoTotal),
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Listado InventariosTelas 333`, 20, 40);
    doc.autoTable({
      // styles: {
      //     valign: 'center'
      // },
      headStyles: {
        valign: "middle",
        halign: "center",
      },
      footStyles: {
        valign: "middle",
        halign: "right",
      },
      columnStyles: {
        0: { minCellWidth: 20 },
        1: { minCellWidth: 20 },
        2: { minCellWidth: 18 },
        3: { minCellWidth: 10, fontSize: 8 },
        4: {
          minCellWidth: 20,
          // valign: 'center'
        },
        5: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        6: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        // 7:{ minCellWidth: 20,
        //   // valign: 'center'
        //  },
        8: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        9: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        10: {
          minCellWidth: 22,
          halign: "right",
          // valign: 'center'
        },
        11: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
        12: {
          minCellWidth: 20,
          halign: "center",
          // valign: 'center'
        },
      },
      head: [
        [
          "Codigo",
          "Nombre",
          "Color",
          "Composicion",
          "Unidad",
          "Ancho",
          "Peso",
          // "Costo",
          "Cantidad",
          "Costo Total",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      // styles: {overflow: 'linebreak'},
      // columnStyles: {
      // "Codigo": {minCellWidth: 50},
      // "Nombre": {minCellWidth: 50},
      // "Color": {minCellWidth: 50},
      // "Composicion": {minCellWidth: 50},
      // "Unidad": {minCellWidth: 50},
      // "Ancho": {minCellWidth: 50},
      // "Peso": {minCellWidth: 50},
      // "Tipo de Tela": {minCellWidth: 50},
      // "Venta": {minCellWidth: 50},
      //   Cantidad: {cellWidth: 300},
      //  },
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US").format(total_general),
          "$" + new Intl.NumberFormat("en-US").format(total_generalCosto),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado InventariosTelas",
          email: mailTo,
          fileName: "ListadoInventariosTelas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de InventariosTelas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function PDFTablaRollo() {
    let total_general = 0;
    const data = inventariosTelasRollos
      .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
      .map((a) => {
        if (a.idTela == articuloDesgloce && a.colores == colorDesgloce) {
          total_general = total_general + a.cantidad;
          return [
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "# " + a.idCompras,
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 159, 10, 31, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 20, 60, 25);

    doc.text(`Listado InventarioTelas por Rollo`, 22, 20);
    doc.setFontSize(12);
    doc.text(`Codigo: ${codigoDesgloce}`, 22, 30);
    doc.text(`Nombre: ${nombreDesgloce}`, 80, 30);
    doc.text(`Color: ${colorDesgloce}`, 22, 35);
    doc.text(`Unidad: ${unidadDesgloce}`, 80, 35);
    doc.text(`Composicion: ${composicionDesgloce}`, 80, 40);
    doc.text(`Ancho: ${anchoDesgloce}`, 22, 50);
    doc.text(`Peso: ${pesoDesgloce}`, 80, 45);
    doc.autoTable({
      showHead: "firstPage",
      head: [["Cantidad", "Compra"]],
      body: dataPDFLimpia,
      startY: 55,
      foot: [[new Intl.NumberFormat("en-US").format(total_general)]],
    });
    doc.save(`InventariosTelas.pdf`);
  }

  function excelRollo() {
    const dataExcel = inventariosTelas.map((a) => {
      if (a.idTela == articuloDesgloce && a.colores == colorDesgloce) {
        return {
          Cantidad: a.cantidad,
          Compra: a.idCompras,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoInventariosTelas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoInventariosTelas",
        sheetFilter: ["Cantidad", "Compra"],
        sheetHeader: ["Cantidad", "Compra"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMailRollo() {
    let total_general = 0;
    const data = inventariosTelasRollos
      .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
      .map((a) => {
        if (a.idTela == articuloDesgloce && a.colores == colorDesgloce) {
          total_general = total_general + a.cantidad;
          return [
            new Intl.NumberFormat("en-US").format(a.cantidad),
            "# " + a.idCompras,
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 159, 10, 31, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 20, 60, 25);

    doc.text(`Listado InventarioTelas por Rollo`, 22, 20);
    doc.setFontSize(12);
    doc.text(`Codigo: ${codigoDesgloce}`, 22, 30);
    doc.text(`Nombre: ${nombreDesgloce}`, 80, 30);
    doc.text(`Color: ${colorDesgloce}`, 22, 35);
    doc.text(`Unidad: ${unidadDesgloce}`, 80, 35);
    doc.text(`Composicion: ${composicionDesgloce}`, 80, 40);
    doc.text(`Ancho: ${anchoDesgloce}`, 22, 50);
    doc.text(`Peso: ${pesoDesgloce}`, 80, 45);
    doc.autoTable({
      showHead: "firstPage",
      head: [["Cantidad", "Compra"]],
      body: dataPDFLimpia,
      startY: 55,
      foot: [[new Intl.NumberFormat("en-US").format(total_general)]],
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado InventariosTelas",
          email: mailTo,
          fileName: "ListadoInventariosTelas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de InventariosTelas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Color", field: "colores", sortable: true },
    { name: "Unidad", field: "unidad", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
  ];

  const commentsData = useMemo(() => {
    let agrupado = comments.reduce(function (groups, item) {
      // Agrupado solo por material y color.
      const val = item["idTela"] + item["idColores"];
      groups[val] = groups[val] || {
        idTela: item.idTela,
        idColores: item.idColores,
        idProveedor: item.idProveedor,
        idCompras: item.idCompras,
        cantidad: 0,
        metros2: 0,
        rollos: 0,
        apartado: 0,
        disponible: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val].apartado += item.apartado;
      groups[val].disponible += item.disponible;
      groups[val].metros2 += item.metros2;
      groups[val]._id = item._id;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].nombre = item.nombre;
      groups[val].idTela = item.idTela;
      groups[val].composicion = item.composicion;
      groups[val].descripcion = item.descripcion;
      groups[val].unidad = item.unidad;
      groups[val].ancho = item.ancho;
      groups[val].peso = item.peso;
      groups[val].rendimiento = item.rendimiento;
      groups[val].idColecciones = item.idColecciones;
      groups[val].colecciones = item.colecciones;
      groups[val].costo = item.costo;
      groups[val].costoTotal = item.costoTotal;
      groups[val].observaciones = item.observaciones;
      groups[val].colores = item.colores;
      groups[val].idColores = item.idColores;
      groups[val].rollos += item.rollos;
      groups[val].idProveedor = item.idProveedor;
      groups[val].idCompras = item.idCompras;
      groups[val].compras = item.compras;
      groups[val].proveedor = item.proveedor;
      groups[val].factura = item.factura;
      groups[val].fechaCompra = item.fechaCompra;
      groups[val].observacionesCompra = item.observacionesCompra;
      return groups;
    }, []);

    let computedComments = Object.values(agrupado);

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
          comment.composicion.toLowerCase().includes(search.toLowerCase()) ||
          comment.unidad.toLowerCase().includes(search.toLowerCase()) ||
          comment.colecciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.proveedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.colores.toLowerCase().includes(search.toLowerCase()) ||
          comment.factura.toLowerCase().includes(search.toLowerCase()) ||
          comment.observacionesCompra.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.apartado.toString().includes(search) ||
          comment.disponible.toString().includes(search) ||
          comment.ancho.toString().includes(search) ||
          comment.peso.toString().includes(search) ||
          comment.costo.toString().includes(search) ||
          comment.costoTotal.toString().includes(search) ||
          comment.rollos.toString().includes(search) ||
          comment.compras.toString().includes(search) ||
          comment.metros2.toString().includes(search) ||
          comment.codigo.toString().includes(search)
      );
    }

    if (selectedColeccionesFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idColecciones.includes(selectedColeccionesFiltro)
      );
    }

    if (selectedColor) {
      computedComments = computedComments.filter((e) =>
        e.idColores.includes(selectedColor)
      );
    }
    if (selectedCodigo) {
      computedComments = computedComments.filter((e) =>
        e.idTela.includes(selectedCodigo)
      );
    }
    if (selectedNombre) {
      computedComments = computedComments.filter((e) =>
        e.idTela.includes(selectedNombre)
      );
    }
    if (unidad) {
      computedComments = computedComments.filter((e) =>
        e.unidad.includes(unidad)
      );
    }
    if (selectedComposicion) {
      computedComments = computedComments.filter((e) =>
        e.composicion.includes(selectedComposicion)
      );
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) =>
        e.idProveedor.includes(selectedProveedor)
      );
    }

    if (mayorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad >= mayorQue
      );
    }

    if (menorQue) {
      computedComments = computedComments.filter(
        (e) => e.cantidad <= menorQue
      );
    }

    let rol = computedComments.map((c) => parseFloat(c.rollos));
    let TRol = rol.reduce((t, rollos, index) => t + rollos, 0);
    setTotalRol(TRol);

    let met = computedComments.filter((e) => e.unidad == "Metros");
    let cant = met.map((c) => parseFloat(c.cantidad));
    let TCant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalCantidadMetros(TCant);

    let kil = computedComments.filter((e) => e.unidad == "Kilos");
    let cantK = kil.map((c) => parseFloat(c.cantidad));
    let TKil = cantK.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalCantidadKilos(TKil);

    let cantM2 = computedComments.map((c) => parseFloat(c.metros2));
    let TM2 = cantM2.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalCantidadMetros2(TM2);

    let cos = computedComments.map((c) => parseFloat(c.costoTotal));
    let TCos = cos.reduce((t, costoTotal, index) => t + costoTotal, 0);
    setTotalCosto(TCos);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "apartado" &&
      sorting.field != "disponible" &&
      sorting.field != "metros2" &&
      sorting.field != "ancho" &&
      sorting.field != "peso" &&
      sorting.field != "costo" &&
      sorting.field != "costoTotal" &&
      sorting.field != "rollos" &&
      sorting.field != "codigo" &&
      sorting.field != "comrpas" &&
      sorting.field != "costoMt"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "apartado" ||
        sorting.field == "disponible" ||
        sorting.field == "metros2" ||
        sorting.field == "ancho" ||
        sorting.field == "peso" ||
        sorting.field != "costo" ||
        sorting.field != "costoTotal" ||
        sorting.field != "rollos" ||
        sorting.field != "codigo" ||
        sorting.field != "compras" ||
        sorting.field != "costoMt")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cantidad" ||
        sorting.field == "apartado" ||
        sorting.field == "disponible" ||
        sorting.field == "metros2" ||
        sorting.field == "ancho" ||
        sorting.field == "peso" ||
        sorting.field != "costo" ||
        sorting.field != "costoTotal" ||
        sorting.field != "rollos" ||
        sorting.field != "codigo" ||
        sorting.field != "compras" ||
        sorting.field != "costoMt")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedColeccionesFiltro,
    selectedColor,
    selectedCodigo,
    selectedNombre,
    unidad,
    selectedComposicion,
    selectedProveedor,
    mayorQue,
    menorQue
  ]);

  function desgloce(
    idTela,
    color,
    nombre,
    codigo,
    peso,
    composicion,
    unidad,
    ancho,
    idColores,
    idProveedor,
    idCompras
  ) {
    setArticuloDesgloce(idTela);
    setColorDesgloce(color);
    setNombreDesgloce(nombre);
    setCodigoDesgloce(codigo);
    setPesoDesgloce(peso);
    setComposicionDesgloce(composicion);
    setUnidadDesgloce(unidad);
    setAnchoDesgloce(ancho);
    setIdProveedorDesgloce(idProveedor);
    setIdComprasDesgloce(idCompras);

    axios
      .get(`${URL_INVENTARIOS_TELAS}Tela/${idTela}/${idColores}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventariosTelas = response.data
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              cantidad: a.cantidad,
              codigo: a.telas[0].codigo,
              nombre: a.telas[0].nombre,
              idTela: a.telas[0]._id,
              composicion: a.telas[0].composicion,
              descripcion: a.telas[0].descripcion,
              unidad: a.telas[0].unidad,
              ancho: a.telas[0].ancho,
              peso: a.telas[0].peso,
              rendimiento: a.telas[0].rendimiento,
              costo: a.telas[0].costo,
              observaciones: a.telas[0].observaciones,
              colores: a.colores && a.colores[0] ? a.colores[0].name : "",
              idColores: a.colores && a.colores[0] ? a.colores[0]._id : "",
              idCompras: a.compras[0].idCompras,
              factura: a.compras[0].factura_proveedor,
              idComprasDesg: a.compras[0]._id,
              idProveedor: a.telasOC[0].ordenesCompra[0].proveedores[0]._id,
              proveedor:
                a.telasOC[0].ordenesCompra[0].proveedores[0]
                  .nombre_comercial,
              apartado:a.apartado,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(allInventariosTelas);
        setInventariosTelasRollos(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleDesgloce();
  }

  function clear() {
    setIdRolloEdit("");
    setArticuloEdit("");
    setUnidadEdit("");
    setCantidadEdit("");
    setPicos("");
    setStock("");
    setCantidadAnteriorEdit("");
    setProduccionEdit("No");
    setApartadoEdit("No");
    setIdCompraEdit("");
    setNumeroCompraEdit("");
  }

  function editRollo() {
    const URL_INVENTARIOS_TELAS_EDIT = `${URL_INVENTARIOS_TELAS}/${idRolloEdit}`;
    const URL_COMPRA_EDIT = `${URL_COMPRAS}RolloEdit/${idCompraEdit}`;
        axios.patch(
          URL_INVENTARIOS_TELAS_EDIT,
          {
            cantidad: cantidadEdit,
            picos,
            stock
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      // .then(() => {
      //   axios
      //     .patch(
      //       `${URL_COMPRA_EDIT}`,
      //       {
      //         cantidadNuevo: cantidadEdit,
      //         cantidadAnterior: cantidadAnteriorEdit,
      //         unidadEdit: unidadEdit,
      //       },
      //       {
      //         headers: {
      //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //         },
      //       }
      //     )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Rollo",
                detalle: `Rollo ${idRolloEdit} / Cantidad Anterior ${cantidadAnteriorEdit} / Cantidad Nueva ${cantidadEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Actualizado con exito", "success");
            clear();
          });
      // })
      // .catch((error) => {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong!",
      //     footer: `${error.response.data}`,
      //   });
      //   console.log(error);
      // });
  }

  function saveCortarRollo() {
    const URL_INVENTARIOS_TELAS_EDIT = `${URL_INVENTARIOS_TELAS}/${idRolloEdit}`;
        axios.patch(
          URL_INVENTARIOS_TELAS_EDIT,
          {
            cantidad: parseFloat(cantidadEdit) - parseFloat(cantidadCortar),
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios
          .post(
            `${URL_INVENTARIOS_TELAS}`,
            {
              cantidad: cantidadCortar,
              compras: rolloCortar.compras[0]._id,
              telas: rolloCortar.telas[0]._id,
              telasOC: rolloCortar.telasOC[0]._id,
              colores: rolloCortar.colores[0]._id,
              captura: rolloCortar.captura + .1,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Cortar Rollo",
                detalle: `Rollo ${idRolloEdit} / Cantidad Anterior ${cantidadAnteriorEdit} / Cantidad Nueva ${cantidadEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            ).then(()=>{

              axios
              .get(`${URL_INVENTARIOS_TELAS}/${idRolloEdit}`, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              })
              .then((response) => {
                let allRollo = response.data;
                QRGen(allRollo._id, allRollo.telas[0].codigo, allRollo.telas[0].nombre, allRollo.colores[0].name, allRollo.cantidad, allRollo.telas[0].unidad )
              })
              .catch((err) => {
                console.log(err);
              });

              axios
              .get(`${URL_INVENTARIOS_TELAS}/${data.data._id}`, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              })
              .then((response) => {
                let allRollo = response.data;
                QRGen(allRollo._id, allRollo.telas[0].codigo, allRollo.telas[0].nombre, allRollo.colores[0].name, allRollo.cantidad, allRollo.telas[0].unidad )
              })
              .catch((err) => {
                console.log(err);
              });

              Swal.fire("Good job!", "Actualizado con exito", "success");
              clear();
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function BuscaArticulo(event) {
    if (event.target.value.length >= 24) {
      axios
        .get(`${URL_INVENTARIOS_TELAS}/${event.target.value}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allRollo = response.data;
          setRolloCortar(allRollo)
          setIdRolloEdit(allRollo._id);
          setArticuloEdit(
            allRollo.telas[0].nombre + " / " + allRollo.colores[0].name
          );
          setUnidadEdit(allRollo.telas[0].unidad);
          setCantidadEdit(allRollo.cantidad);
          setCantidadAnteriorEdit(allRollo.cantidad);
          setPicos(allRollo.picos);
          setStock(allRollo.Stock);
          setProduccionEdit(allRollo.produccion);
          setApartadoEdit(allRollo.apartado);
          setIdCompraEdit(allRollo.compras[0]._id);
          setNumeroCompraEdit(allRollo.compras[0].idCompras);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setIdRolloEdit(event.target.value);
    }
  }

  function BuscaArticuloHistorial(event) {
    if (event.target.value.length >= 24) {
      axios
        .get(`${URL_INVENTARIOS_TELAS}/${event.target.value}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allRolloHistorial = response.data;
          setIdRolloHistorial(allRolloHistorial._id);
          setArticuloHistorial(
            allRolloHistorial.telas[0].nombre +
              " / " +
              allRolloHistorial.colores[0].name
          );
          setUnidadHistorial(allRolloHistorial.telas[0].unidad);
          setCantidadHistorial(allRolloHistorial.cantidad);
          setCantidadAnteriorHistorial(allRolloHistorial.cantidad);
          setProduccionHistorial(allRolloHistorial.produccion);
          setIdCompraHistorial(allRolloHistorial.compras[0]._id);
          setNumeroCompraHistorial(allRolloHistorial.compras[0].idCompras);
          if (allRolloHistorial.produccion == "No") {
            setSurtidoHistorial("El Rollo no ha sido surtido");
          } else {
            setSurtidoHistorial(allRolloHistorial.surtidos[0].idSurtido);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setIdRolloHistorial(event.target.value);
    }
  }

  function limpiarSearch() {
    setSearch("");
    setSelectedArticulo("");
    setSelectedCodigo("");
    setSelectedNombre("");
    setSelectedColor("");
    setSelectedComposicion("");
    setSelectedProveedor("");
    setUnidad("");
  }

  function QRGeneral() {


        const doc = new jsPDF("p", "mm", [102, 80]);
        let alturaLogo = 30;
        let alturaImagen = 60;
        let alturaTexto1 = 43;
        let alturaTexto2 = 48;
        let alturaTexto3 = 53;
        let alturaTexto4 = 58;
        let alturaTexto5 = 68;
        let alturaLogo2 = 35;

        inventariosTelasRollos
          .sort((a, b) => (a.captura > b.captura ? 1 : -1))
          .map((a) => {
            let codigo = a._id;
            var base64 = qrcode.toDataURL(codigo);
            var img = new Image();
            img.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
            doc.addImage(img, "png", 70, alturaLogo, 35, 10, null, null, 90);

            var img2 = new Image();
            img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
            doc.addImage(img2, "png", 40, alturaLogo2, 60, 25, null, null, 90);

            var img3 = new Image();
            img3.src = base64;
            doc.addImage(img3, "png", 0, alturaImagen, 40, 40);

            doc.setFontSize(11);
            doc.text(`Cod ${a.codigo} Mod ${a.nombre}`, alturaTexto1, 90, null, 90);
            doc.text(`Prov. ${a.proveedor}`, alturaTexto2, 90, null, 90);
            doc.text(`Factura ${a.factura}, Color ${a.colores}`, alturaTexto3, 90, null, 90);
            doc.text(`ID ${a._id}`, alturaTexto4, 90, null, 90);

            doc.setFontSize(18);
            doc.text(
              `Cant. ${a.cantidad} ${a.unidad}`,
              alturaTexto5,
              90,
              null,
              90
            );
            doc.addPage();
          });
        // doc.save(`QR.pdf`);
        window.open(doc.output("bloburl"), "_blank");

  }

  function QRGen(id, codigo, nombre, color, cantidad, unidad, proveedor, factura) {
    const doc = new jsPDF("p", "mm", [102, 80]);
    let alturaLogo = 30;
    let alturaImagen = 60;
    let alturaTexto1 = 43;
    let alturaTexto2 = 48;
    let alturaTexto3 = 53;
    let alturaTexto4 = 58;
    let alturaTexto5 = 68;
    let alturaLogo2 = 35;

    let codigoQR = id;
    var base64 = qrcode.toDataURL(codigoQR);
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-Negro.png";
    doc.addImage(img, "png", 70, alturaLogo, 35, 10, null, null, 90);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 40, alturaLogo2, 60, 25, null, null, 90);
    var img3 = new Image();
    img3.src = base64;
    doc.addImage(img3, "png", 0, alturaImagen, 40, 40);

    doc.setFontSize(11);
    doc.text(`Cod ${codigo} Mod ${nombre}`, alturaTexto1, 90, null, 90);
    doc.text(`Prov. ${proveedor}`, alturaTexto2, 90, null, 90);
    doc.text(`Factura ${factura}, Color ${color}`, alturaTexto3, 90, null, 90);
    doc.text(`ID ${id}`, alturaTexto4, 90, null, 90);
    doc.setFontSize(18);
    doc.text(`Cant. ${cantidad} ${unidad}`, alturaTexto5, 90, null, 90);
    doc.save(`QR.pdf`);
  }

  function detalleApartado(
    idTela,
    nombre,
    codigo,
    idColores,
    color,
    idCompras
  ) {
    setIdTelaApartado(idTela);
    setNombreApartado(nombre);
    setCodigoApartado(codigo);
    setIdColorApartado(idColores);
    setColorApartado(color);
    setIdComprasApartado(idCompras);
    setApartadoTelas([])
    axios
      .get(`${URL_APARTADO_TELAS}/${idTela}/${idColores}/${idCompras}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allApartadoTelas = response.data
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              cantidad: a.cantidad,
              codigo: a.telas[0].codigo,
              nombre: a.telas[0].nombre,
              idTela: a.telas[0]._id,
              colores: a.colores[0].name,
              idColores: a.colores[0]._id,
              idCompras: a.compras[0].idCompras,
              observaciones: a.observaciones,
              pedidos: a.pedidos[0].idPedido,
              cliente: a.pedidos[0].clientes[0].nombre_comercial,
              articulo: a.pedidos[0].articulos[0].codigo + " " + a.pedidos[0].articulos[0].codigoCliente + " " + a.pedidos[0].articulos[0].descripcion,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(allApartadoTelas);
        setApartadoTelas(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    toggleApartado();
  }

  const saveApartadoTela = async (event) => {
    event.preventDefault();
  
    if (selectedPedido && observacionesApartado && cantidadApartado > 0) {
      setValidaBoton(false);
      toggleProgreso();
  
      try {
        await axios.post(
          URL_APARTADO_TELAS,
          {
            telas: idTelaApartado,
            colores: idColorApartado,
            compras: idComprasApartado,
            pedidos: selectedPedido,
            observaciones: observacionesApartado,
            cantidad: cantidadApartado,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
  
        Swal.fire("Good job!", `Creado con exito`, `success`);
        toggleApartado(false);
        setModalProgreso(false);
        setSelectedPedido("");
        setValue("");
        setObservacionesApartado("");
        setCantidadApartado(0);
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data || error.message}`,
        });
        setValidaBoton(true);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Verifica que hayas llenado todos los campos necesarios",
      });
    }
  };

  function bajaApartado(id) {
    axios
      .patch(
        `${URL_APARTADO_TELAS}/${id}`,
        {
          is_active: "No"
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem(
              "app_token"
            )}`,
          },
        }
      )
      .then((data) => {
            Swal.fire("Good job!", "Creado con exito", "success");
            toggleApartado(false);
            setModalProgreso(false);
            // const newBoniCliente = boniCliente.map((i) => {
            //   if (id === i.id) {
            //     i.is_active = "No";
            //   }
            //   return i;
            // });
            // setBoniCliente(newBoniCliente);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          // footer: `${error.response.data}`,
        });
        console.log(error);
      });
}
  

  const options = pedidos.map((option) => {
    const junta = option.idPedido + " " + option.clientes[0].nombre_comercial + " " + option.articulos[0].codigo + " " + option.articulos[0].codigoCliente + " " + option.articulos[0].descripcion;
    const firstLetter = option.idPedido.toString();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "inventarios.materiaPrima.ver") ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
             
              {/* <Button
                size="sm"
                className="btn"
                color="info"
                onClick={toggleHistorialRollo}
              >
                Historial Articulo
              </Button> */}

             
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios Telas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <Modal size="sm" isOpen={modalMailRollo} toggle={toggleMailRollo}>
            <ModalHeader toggle={toggleMailRollo}>
              <h4>Enviar InventarioTelas por rollo</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMailRollo}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-fill" style={{ marginRight: 8, color: "#10b981" }} />
                Inventario Materia Prima
              </h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>{" "}
            <div className="col-md-1 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-1 flex-row-reverse">
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={limpiarSearch}
              >
                Limpiar
              </Button>
            </div>
          </div>

          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Mayor Que</Label>
              <Input
                bsSize="sm"
                type="number"
                value={mayorQue}
                required
                onChange={(e) => {
                  setMayorQue(Number(e.target.value)); // Convierte a número
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Menor Que</Label>
              <Input
                bsSize="sm"
                type="number"
                value={menorQue}
                required
                onChange={(e) => {
                  setMenorQue(Number(e.target.value)); // Convierte a número
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCodigo}
                  onChange={(e) => {
                    setSelectedCodigo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulosCodigos
                    .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idTela}>{a.codigo}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedNombre}
                  onChange={(e) => {
                    setSelectedNombre(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {articulosNombre
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a.idTela}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColor}
                  onChange={(e) => {
                    setSelectedColor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  placeholder="Unidad"
                  value={unidad}
                  required
                  onChange={(e) => {
                    setUnidad(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Metros">Metros</option>
                  <option value="Kilos">Kilos</option>
                </Input>
              </td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.codigo}</td>
                      <td>{a.nombre}</td>
                      <td>{a.colores}</td>
                      <td>{a.unidad}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  Metros:{" "}
                  {new Intl.NumberFormat("en-US").format(totalCantidadMetros)}
                  {" / "}Kilos:{" "}
                  {new Intl.NumberFormat("en-US").format(totalCantidadKilos)}
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modalDesgloce} toggle={toggleDesgloce}>
        <ModalHeader toggle={toggleDesgloce}>
          <h4>InventarioTelas del articulo</h4>
        </ModalHeader>
        <ModalBody>
          {/* <div className="card container"> */}
          <Row>
            <Col sm={12}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTablaRollo}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMailRollo}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelRollo}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="success"
                  onClick={(e) => QRGeneral()}
                >
                  General <i class="fas fa-qrcode"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label> Codigo: {codigoDesgloce} </Label>
            </Col>
            <Col md={4}>
              <Label> Nombre: {nombreDesgloce} </Label>
            </Col>
            <Col md={4}>
              <Label> Unidad: {unidadDesgloce} </Label>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label> Color: {colorDesgloce}</Label>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Label> Comp: {composicionDesgloce} </Label>
            </Col>
            <Col md={4}>
              <Label> Ancho: {anchoDesgloce}</Label>
            </Col>
            <Col md={4}>
              <Label>Peso: {pesoDesgloce}</Label>
            </Col>
          </Row>
          <br />
          <br />
          <Table size="sm" striped bordered className="table-responsive-xl table-dark-header">
            <tr>
              <th>ID</th>
              <th>{unidadDesgloce}</th>
              <th>Compra</th>
              <th>QR</th>
            </tr>
            <tbody>
              {inventariosTelasRollos.map((a) => {
                if (
                  a.idProveedor == idProveedorDesgloce &&
                  a.idComprasDesg == idComprasDesgloce
                ) {
                  return (
                    <tr>
                      <td>{a._id}</td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td># {a.idCompras}</td>
                      <td>
                        <Button
                          size="sm"
                          className="btn"
                          color="success"
                          onClick={(e) =>
                            QRGen(
                              a._id,
                              a.codigo,
                              a.nombre,
                              a.colores,
                              a.cantidad,
                              a.unidad,
                              a.proveedor,
                              a.factura
                            )
                          }
                        >
                          <i class="fas fa-qrcode"></i>
                        </Button>
                      </td>
                    </tr>
                  );
                }
              })}
            </tbody>
          </Table>
          {/* </div> */}
        </ModalBody>
      </Modal>

      {/* Modal Edit Rollo */}
      <Modal size="xl" isOpen={modalEditRollo} toggle={toggleEditRollo}>
        <ModalHeader toggle={toggleEditRollo}>
          <h4>
            <i className="fas fa-edit" style={{ marginRight: 8, color: "#10b981" }} />
            Editar Rollo
          </h4>
        </ModalHeader>
        <ModalBody>
          {produccionEdit == "Si" || apartadoEdit == "Si" ? (
            <Label className="mr-sm-2">
              El Rollo ya fue produccion o apartado, no se puede editar.
            </Label>
          ) : undefined}

          <br />

          <div className="form-section">
            <div className="form-section-header">
              <i className="fas fa-scroll" />
              <span className="form-section-title">Datos del Rollo</span>
            </div>
            <div className="form-section-body">
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Codigo</Label>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Unidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Compra</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Picos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Stock</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Input
                bsSize="sm"
                name="idRolloEdit"
                type="string"
                value={idRolloEdit}
                onChange={(event) => {
                  BuscaArticulo(event);
                }}
              ></Input>
            </Col>
            <Col md={4}>
              <Input
                bsSize="sm"
                name="articuloEdit"
                type="string"
                value={articuloEdit}
                disabled
              ></Input>
            </Col>
            <Col md={1}>
              <Input
                bsSize="sm"
                name="unidadEdit"
                type="string"
                value={unidadEdit}
                disabled
              ></Input>
            </Col>
            <Col md={1}>
              <Input
                bsSize="sm"
                name="numeroCompraEdit"
                type="string"
                value={numeroCompraEdit}
                disabled
              ></Input>
            </Col>
            {produccionEdit == "No" || apartadoEdit == "Si" ? (
              <>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cantidadEdit"
                    type="string"
                    value={cantidadEdit}
                    onChange={(event) => {
                      setCantidadEdit(event.target.value);
                    }}
                    // disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="picos"
                    type="select"
                    value={picos}
                    required
                    onChange={(event) => {
                      setPicos(event.target.value);
                    }}
                  >
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="stock"
                    type="select"
                    value={stock}
                    required
                    onChange={(event) => {
                      setStock(event.target.value);
                    }}
                  >
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>
              </>
            ) : (
              <>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cantidadEdit"
                    type="string"
                    disabled
                    value={cantidadEdit}
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="picos"
                    type="string"
                    value={picos}
                    required
                    disabled
                  />
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="stock"
                    type="string"
                    value={stock}
                    required
                    disabled
                  />
                </Col>
              </>
            )}
          </Row>
            </div>
          </div>
          <br />
          <Row>
            <Col>
              {produccionEdit == "No" || apartadoEdit == "Si" ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={editRollo}
                >
                  <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="btn btn-success"
                  disabled
                  tabindex="-1"
                >
                  Guardar
                </Button>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Modal Historial Rollo */}
      <Modal
        size="xl"
        isOpen={modalHistorialRollo}
        toggle={toggleHistorialRollo}
      >
        <ModalHeader toggle={toggleHistorialRollo}>
          <h4>Historial de Rollo</h4>
        </ModalHeader>
        <ModalBody>
          <br />

          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Codigo</Label>
            </Col>
            <Col md={4}>
              <Label className="mr-sm-2">Articulos</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Unidad</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Compra</Label>
            </Col>
            <Col md={1}>
              <Label className="mr-sm-2">Cantidad</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Input
                bsSize="sm"
                name="idRolloHistorial"
                type="string"
                value={idRolloHistorial}
                onChange={(event) => {
                  BuscaArticuloHistorial(event);
                }}
              ></Input>
            </Col>
            <Col md={4}>
              <Input
                bsSize="sm"
                name="articuloHistorial"
                type="string"
                value={articuloHistorial}
                disabled
              ></Input>
            </Col>
            <Col md={1}>
              <Input
                bsSize="sm"
                name="unidadHistorial"
                type="string"
                value={unidadHistorial}
                disabled
              ></Input>
            </Col>
            <Col md={1}>
              <Input
                bsSize="sm"
                name="numeroCompraHistorial"
                type="string"
                value={numeroCompraHistorial}
                disabled
              ></Input>
            </Col>

            <Col md={1}>
              <Input
                bsSize="sm"
                name="cantidadHistorial"
                type="string"
                disabled
                value={cantidadHistorial}
              ></Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <Label> Numero de Surtido {surtidoHistorial}</Label>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* Modal Cortar Rollo */}
      <Modal size="xl" isOpen={modalCortarRollo} toggle={toggleCortarRollo}>
        <ModalHeader toggle={toggleCortarRollo}>
          <h4>Cortar Rollo</h4>
        </ModalHeader>
        <ModalBody>
          <Col md={3}>
            <Label className="mr-sm-2">Codigo</Label>
          </Col>

          <Col md={3}>
            <Input
              bsSize="sm"
              name="idRolloEdit"
              type="string"
              value={idRolloEdit}
              onChange={(event) => {
                BuscaArticulo(event);
              }}
            ></Input>
          </Col>

          {produccionEdit == "Si" || apartadoEdit == "Si" ? (
            <>
              <br />
              <Label className="mr-sm-2">
                El Rollo ya esta en produccion, no se puede cortar.
              </Label>
            </>
          ) : (
            <>
              <br />

              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Compra</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Cantidad a Cortar</Label>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Input
                    bsSize="sm"
                    name="articuloEdit"
                    type="string"
                    value={articuloEdit}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="unidadEdit"
                    type="string"
                    value={unidadEdit}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="numeroCompraEdit"
                    type="string"
                    value={numeroCompraEdit}
                    disabled
                  ></Input>
                </Col>
                <Col md={1}>
                  <Input
                    bsSize="sm"
                    name="cantidadEdit"
                    type="string"
                    value={cantidadEdit}
                    disabled
                  ></Input>
                </Col>

                <Col md={2}>
                  <Input
                    bsSize="sm"
                    name="cantidadCortar"
                    type="string"
                    value={cantidadCortar}
                    onChange={(event) => {
                      if (event.target.value < cantidadEdit) {
                        setCantidadCortar(event.target.value);
                      } else {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "La cantidad a cortar no puede ser mayor o igual a la cantidad del rollo",
                        });
                        setCantidadCortar(0);
                      }
                    }}
                  ></Input>
                </Col>
              </Row>
              <br />
              <Row>
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    tabindex="-1"
                    onClick={saveCortarRollo}
                  >
                    Guardar
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>

      <Modal size="xl" isOpen={modalApartado} toggle={toggleApartado}>
        <ModalHeader toggle={toggleApartado}>
          <h4>Apartados</h4>
        </ModalHeader>
        <ModalBody>
          {/* <div className="card container"> */}
          {/* <Row>
            <Col sm={12}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTablaRollo}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMailRollo}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelRollo}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                <Button
                                size="sm"
                                className="btn"
                                color="success"
                                onClick={(e) => QRGeneral()}
                              >
                                General <i class="fas fa-qrcode"></i>
                              </Button>
              </ButtonGroup>
            </Col>
          </Row> */}
          <Row>
            <Col md={4}>
              <Label> Codigo: {codigoApartado} </Label>
            </Col>
            <Col md={4}>
              <Label> Nombre: {nombreApartado} </Label>
            </Col>
            <Col md={4}>
              <Label> Color: {colorApartado}</Label>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={2}>
              <Label>Cantidad</Label>
              <Input
                type="number"
                // bsSize="sm"
                value={cantidadApartado}
                onChange={(e) => setCantidadApartado(e.target.value)}
                placeholder="Cantidad"
              />
            </Col>

            <Col md={4}>
              <Label>Pedido</Label>
              <Label className="mr-sm-2">Pedido</Label>
              <Autocomplete
                size="small"
                value={value}
                onChange={(event, selectedPedido) => {
                  if (selectedPedido) {
                    setValue(selectedPedido);
                    setSelectedPedido(selectedPedido._id);
                  }
                }}
                options={options.sort(
                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                )}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.junta}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Selecciona"
                    variant="outlined"
                  />
                )}
                renderOption={(option) => (
                  <React.Fragment>
                    {option.idPedido} {option.clientes[0].nombre_comercial}{" "}
                    {option.articulos[0].codigo}{" "}
                    {option.articulos[0].codigoCliente}{" "}
                    {option.articulos[0].descripcion}
                  </React.Fragment>
                )}
              />
            </Col>

            <Col md={4}>
              <Label>Observaciones</Label>
              <Input
                type="text"
                // bsSize="sm"
                value={observacionesApartado}
                onChange={(e) => setObservacionesApartado(e.target.value)}
                placeholder="Observaciones"
              />
            </Col>

            <Col md={2} className="d-flex align-items-end">
              <Button color="primary" size="sm" onClick={saveApartadoTela}>
                Guardar
              </Button>
            </Col>
          </Row>

          <br />
          <br />
          <Table size="sm" striped bordered className="table-responsive-xl table-dark-header">
            <tr>
              <th>Pedido</th>
              <th>Cliente</th>
              <th>Articulo</th>
              <th>Cantidad</th>
              <th>Observaciones</th>
              <th>Quitar</th>
            </tr>
            <tbody>
              {apartadoTelas.map((a) => {
                return (
                  <tr>
                    <td>{a.pedidos}</td>
                    <td>{a.cliente}</td>
                    <td>{a.articulo}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                    <td>{a.observaciones}</td>
                    <td>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={() => bajaApartado(a._id)}
                        tabindex="-1"
                      >
                        <i class="far fa-times-circle"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {/* </div> */}
        </ModalBody>
      </Modal>

                <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
                  <ModalHeader toggle={toggleProgreso}>
                    <h4>Progreso</h4>
                  </ModalHeader>
                  <ModalBody>
                    <h4>
                      {" "}
                      Este proceso puede tardar varios minutos.
                      <br />
                      Por favor no cierre ni refresque su navegador.
                    </h4>
                    <br />
                    <div className="progreso">
                      <Spinner
                        style={{
                          width: "50px",
                          height: "50px",
                          color: "#232B41",
                        }}
                      />
                      <Spinner
                        style={{
                          width: "50px",
                          height: "50px",
                          color: "#232B41",
                        }}
                      />
                      <Spinner
                        style={{
                          width: "50px",
                          height: "50px",
                          color: "#232B41",
                        }}
                      />
                    </div>
                  </ModalBody>
                </Modal>
      {loader}
    </>
  );
}

export default ListadoInventariosTelas;
